import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthProvider';
import { ROUTES } from '../../ui/navigation/routes';

/**
 * Layout-route gate for the four Administration screens (Master Phase 11).
 *
 * A UX convenience only — never the security boundary. It exists so a
 * non-admin never sees a confusing 403 page, just lands back on Settings;
 * every `/api/admin/*` endpoint independently re-checks `role === 'admin'`
 * server-side regardless of what this gate does (approved plan §8/§9).
 *
 * Silent redirect, not an error page — matching this codebase's existing
 * indistinguishable-failure posture (e.g. `genericAuthFailure()`'s 401):
 * confirming "you're logged in but not allowed" to the wrong audience is
 * exactly what this avoids.
 */
export function AdminOnlyGate(): React.JSX.Element {
  const { role } = useAuth();

  if (role !== 'admin') {
    return <Navigate to={ROUTES.settings} replace />;
  }

  return <Outlet />;
}
